import { quoteOrderStatus } from '@teinor/erp/types/company/order/quote/quoteOrder';
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary';
import { preciseDecimalSum } from '@teinor/erp/prices';
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types';
import { getCurrencySymbol } from '../../../../../../../utils/globals/price';
import { getEmployeeParams, getEmployees, getISOCurrencyMain } from '../../../../../../../utils/reducers/getters';
import { displayFormatedNumber } from '../../../../../../../utils/globals/numbers';
import { getOnlyDefaultColumns, SelectedColumnsAndFilters } from '../../../../../../../utils/hooks/useConfigColumns';
import { TypeSellTableNameTy, TypeSellTy, TypeStatsTy } from './types';
import { sellOrderStatus } from '@teinor/erp/types/company/order/sell/sellOrder';
import { sellDeliveryNoteStatus } from '@teinor/erp/types/company/order/sell/sellDeliveryNote';
import { sellInvoiceStatus } from '@teinor/erp/types/company/order/sell/sellInvoice';

const generateAutoRows = (status: TwinDictionary) => {
    const statusCollection: TwinDictionary = {
        totalN: 0, 
        totalPercentatge: 0,
        totalAmount: 0,
        totalFacturationPercentatge: 0
    }
    let rows: string[] = []
    for (const key in status) {
        const element = status[key]
        if (!statusCollection[element + 'N'] && statusCollection[element + 'N'] !== 0) {
            statusCollection[element + 'N'] = 0
            statusCollection[element + 'Percentatge'] = 0
            statusCollection[element + 'Amount'] = 0
            statusCollection[element + 'PercentatgeAmount'] = 0
            rows.push(element + 'N', element + 'Percentatge', element + 'Amount', element + 'PercentatgeAmount',)
        }
    }
    rows = [...rows, 'totalN', 'totalPercentatge', 'totalAmount', 'totalFacturationPercentatge']
    return { rows, statusCollection}
}

const getStatesRowsBase = (typeTableName: TypeSellTableNameTy) => {
    const quoteOrderStatusModifiedForStats = {
        ...quoteOrderStatus,
        5: 'accepted'
    }
    const sellOrderStatusModifiedForStats = {
        ...sellOrderStatus,
        2: 'waitingResponse'
    }
    const sellDeliveryNoteStatusModifiedForStats = {
        ...sellDeliveryNoteStatus,
        2: 'waitingResponse',
        4: 'refunded'
    }
    const sellInvoicesStatusModifiedForStats = {
        ...sellInvoiceStatus,
        3: 'refunded'
    }
    const sellTicketStatusModifiedForStats = {
        1: 'saved',
        2: 'saved',
        3: 'accepted',
        4: 'refunded',
        5: 'refunded',
        6: 'refunded',
    }
    const dictOrderStatus: Record<TypeSellTableNameTy, { dictStatus: TwinDictionary, typeSell: TypeSellTy, typeMainDenied: string }> = {
        'quote': { dictStatus: quoteOrderStatusModifiedForStats, typeSell: 'QuoteOrder', typeMainDenied: 'denied' },
        'sell_order': { dictStatus: sellOrderStatusModifiedForStats, typeSell: 'SellOrder', typeMainDenied: 'denied' },
        'sell_delivery_note': { dictStatus: sellDeliveryNoteStatusModifiedForStats, typeSell: 'SellDeliveryNote', typeMainDenied: 'refunded' },
        'sell_invoice': { dictStatus: sellInvoicesStatusModifiedForStats, typeSell: 'SellInvoice', typeMainDenied: 'refunded' },
        'sell_ticket': { dictStatus: sellTicketStatusModifiedForStats, typeSell: 'SellTicket', typeMainDenied: 'refunded' },
    }
    const {rows, statusCollection} = generateAutoRows(dictOrderStatus?.[typeTableName].dictStatus)
    return ({ rows, dictStatsRows: statusCollection, dictOrderStatus })
}

const getTotalAmounts = (id: string, key: string, totalsFieldName: string, totalAmount: number, data: TwinDictionary, tableName: string, order: TwinDictionary, catName: TypeStatsTy, myTotalAmountDict: TwinDictionary ) => {
    const myData: TwinDictionary = { ...data }
    let myTotalAmount: number = JSON.parse(JSON.stringify(totalAmount))

    if (tableName === 'sell_ticket' && (key === 'accepted' || key === 'refunded')) {
        const cleanWithVat = parseFloat(order?.total_total || 0)
        const refundWithVat = parseFloat(order?.total_refund_with_vat || 0)
        const myTotalCleaned = parseFloat(order?.total_clean_with_vat)
        myData[id]['acceptedAmount'] = parseFloat(preciseDecimalSum(myData[id]['acceptedAmount'], cleanWithVat).toFixed(2))
        myData[id]['refundedAmount'] = parseFloat(preciseDecimalSum(myData[id]['refundedAmount'], refundWithVat).toFixed(2))
        myTotalAmountDict['acceptedAmount'] = {
            amount: parseFloat(preciseDecimalSum(myTotalAmountDict['acceptedAmount']?.amount || 0, cleanWithVat).toFixed(2)),
            quantity: myTotalAmountDict['acceptedAmount']?.quantity || 0
        }
        myTotalAmountDict['refundedAmount'] = {
            amount: parseFloat(preciseDecimalSum(myTotalAmountDict['refundedAmount']?.amount || 0, refundWithVat).toFixed(2)),
            quantity: myTotalAmountDict['refundedAmount']?.quantity || 0
        }
        if (key === 'refunded') {
            myData[id]['acceptedN'] += 1
            myData[id]['refundedN'] += 1
            myTotalAmountDict['acceptedAmount'].quantity = myTotalAmountDict['acceptedAmount'].quantity + 1
            myTotalAmountDict['refundedAmount'].quantity = myTotalAmountDict['refundedAmount'].quantity + 1
        } else {
            myData[id][key + 'N'] += 1
            myTotalAmountDict[key + 'Amount'].quantity = myTotalAmountDict[key + 'Amount'].quantity + 1
        }
        myData[id]['totalN'] += myTotalCleaned ? 1 : 0
        myData[id]['totalAmount'] = parseFloat(preciseDecimalSum(myData[id]['totalAmount'], myTotalCleaned).toFixed(2))
        myTotalAmountDict['totalAmount'] = {
            amount: parseFloat(preciseDecimalSum(myTotalAmountDict['totalAmount']?.amount || 0, myTotalCleaned).toFixed(2)),
            quantity: parseFloat(preciseDecimalSum(myTotalAmountDict['totalAmount']?.quantity || 0, myTotalCleaned ? 1 : 0).toFixed(2))
        }
        myTotalAmount = parseFloat(preciseDecimalSum(myTotalAmount, myTotalCleaned).toFixed(2)) || 0
    } else {
        const total = parseFloat(String(order[totalsFieldName] || 0))
        myData[id][key + 'Amount'] = parseFloat(preciseDecimalSum(myData[id][key + 'Amount'], total).toFixed(2))
        myData[id][key + 'N'] += 1
        myData[id]['totalAmount'] = parseFloat(preciseDecimalSum(myData[id]['totalAmount'], total).toFixed(2))
        myData[id]['totalN'] += 1
        myTotalAmountDict[key+'Amount'] = {
            amount: parseFloat(preciseDecimalSum(myTotalAmountDict[key + 'Amount']?.amount || 0, total).toFixed(2)),
            quantity: parseFloat(preciseDecimalSum(myTotalAmountDict[key + 'Amount']?.quantity || 0, 1).toFixed(2))
        }
        myTotalAmountDict['totalAmount'] = {
            amount: parseFloat(preciseDecimalSum(myTotalAmountDict['totalAmount']?.amount || 0, total).toFixed(2)),
            quantity: parseFloat(preciseDecimalSum(myTotalAmountDict['totalAmount']?.quantity || 0, 1).toFixed(2))
        }
        myTotalAmount = parseFloat(preciseDecimalSum(totalAmount, total).toFixed(2)) || 0
    }
    
    return {data: myData, myTotalAmount}
}

const getTotalStatusStatsPercentatges = (dictOrderStatus: TwinDictionary, tableName: string, data: TwinDictionary, totalAmount: number, totalN: number, CurrencySymbol: any) => {
    const myData: TwinDictionary = JSON.parse(JSON.stringify(data))
    const dictOrder = dictOrderStatus[tableName]
    const status = dictOrder.dictStatus
    for (const key in status) {
        const element = status[key];
        const deniedStatus = dictOrder?.typeMainDenied
        const sumAcceptedAndDenied = parseFloat((myData.acceptedN + myData[deniedStatus + 'N'])?.toFixed(2))
        const sumAcceptedAndDeniedAmount = parseFloat((myData.acceptedAmount + myData[deniedStatus + 'Amount']).toFixed(2))
        const totalForPercentatge = (element === 'accepted' || element === deniedStatus) ? sumAcceptedAndDenied : myData.totalN
        const totalAmountForPercentatge = (element === 'accepted' || element === deniedStatus) ? sumAcceptedAndDeniedAmount : myData.totalAmount
        myData[element + 'Percentatge'] = myData[element + 'N'] ? displayFormatedNumber(((myData[element + 'N'] * 100) / totalForPercentatge).toFixed(2)) + '%' : '0,00%'
        myData[element + 'PercentatgeAmount'] = myData[element + 'Amount'] ? displayFormatedNumber(((myData[element + 'Amount'] * 100) / totalAmountForPercentatge).toFixed(2)) + '%' : '0,00%'
    }
    myData.totalPercentatge = myData.totalN ? displayFormatedNumber(((myData.totalN * 100) / totalN).toFixed(2)) + '%' : '0.00%'
    myData.totalFacturationPercentatge = myData.totalAmount ? displayFormatedNumber(((myData.totalAmount * 100) / totalAmount).toFixed(2)) + '%' : '0.00%'

    for (const key in myData) {
        if (key.includes('Amount') && !key.includes('PercentatgeAmount')) {
            myData[key] = displayFormatedNumber(myData[key]?.toFixed(2)) + CurrencySymbol
        }
    }

    return myData
}

export const parseSellStatsByEmployee = (data: TwinDictionary[], selectedColumnsAndFilters: SelectedColumnsAndFilters, typeTableName: TypeSellTableNameTy) => {
    const employees = getEmployees()
    const myTableEmployeeData = getEmployeeParams()?.['table_employee_' + typeTableName +'_config_stats'] ? JSON.parse(JSON.stringify(selectedColumnsAndFilters)) : getOnlyDefaultColumns([])
    const myEmployeeFilterParameter = myTableEmployeeData?.filters?.EmployeeId ? myTableEmployeeData?.filters?.EmployeeId.value : []
    const myEmployeeOrderParameter = myTableEmployeeData?.order?.EmployeeId || []
    const { rows, dictStatsRows, dictOrderStatus } = getStatesRowsBase(typeTableName)
    let myData: TwinDictionary = {}
    let totalN = 0
    let totalAmount = 0
    let myTotalAmountDict = {}
    let CurrencyId = ''
    for (const element of data) {
        if (!CurrencyId) {
            CurrencyId = element.CurrencyId || ''
        }
        const myEmployee = element.RepresentativeEmployee || element.CreateEmployee
        if (myEmployee?.id) {
            if (!myData[myEmployee.id]) {
                myData[myEmployee.id] = {
                    image: employees?.[myEmployee?.id]?.profile_image,
                    name: myEmployee?.fullname_short,
                    ...dictStatsRows
                }
            }
            const key = dictOrderStatus?.[typeTableName].dictStatus?.[element.status as any]
            const { data, myTotalAmount } = getTotalAmounts(myEmployee.id, key, 'total_without_vat', totalAmount, myData, typeTableName, element, 'EmployeeId', myTotalAmountDict)
            myData = data
            totalAmount = myTotalAmount
            totalN += 1
        }
    } //S'ha de fer aquí roundNumberAndDecimals?
    if (myEmployeeFilterParameter.length) {
        const data = Object.keys(myData)
        for (const key of myEmployeeFilterParameter) {
            if (!data.includes(String(key)) && !myData[key] && employees) {
                const myEmployee = employees[key]
                myData[myEmployee?.id] = {
                    image: employees?.[myEmployee?.id]?.profile_image,
                    name: myEmployee?.fullname_short,
                    ...dictStatsRows
                }
            }
        }
    }
    if (!CurrencyId) {
        CurrencyId = getISOCurrencyMain()
    }
    const result: TwinDictionary[] = []
    const dictionaryRows: TwinDictionary = {}
    const columns: ColumnTableSchema<TwinDictionary> = [
        {
            id: 'row',
            dataKey: 'row',
            label: '',
            width: 300,
        }
    ]
    for (const key in rows) {
        const element = rows[key]
        result.push({ row: element })
        dictionaryRows[element] = key
    }
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    for (const key in myData) {
        let element = myData[key]
        columns.push({
            id: key,
            dataKey: key,
            label: () => (
                <div className='flex items-center'>
                    <img src={element?.image || '/user-png.png'} alt='' className='logo_user rounded-full object-cover mr-10' />
                    <span>{element?.name}</span>
                </div>
            ),
            width: 200,
        })
        element = getTotalStatusStatsPercentatges(dictOrderStatus, typeTableName, element, totalAmount, totalN, CurrencySymbol)
        for (const key2 in element) {
            if (dictionaryRows[key2]) {
                result[dictionaryRows[key2]][key] = element[key2]
            }
        }
        if (myEmployeeOrderParameter.length) {
            columns.sort((a, b) => myEmployeeOrderParameter.indexOf(parseInt(a.id)) - myEmployeeOrderParameter.indexOf(parseInt(b.id)))
        }
    }
    return { data: result, columns: columns, myTotalAmountDict, CurrencyId }
}

export const parseSellStatsByProduct = (data: any[], typeTableName: TypeSellTableNameTy) => {
    const { rows, dictStatsRows, dictOrderStatus } = getStatesRowsBase(typeTableName)
    const info = dictOrderStatus[typeTableName]
    let myData: TwinDictionary = {}
    let totalN = 0
    let totalAmount = 0
    let myTotalAmountDict = {}
    let CurrencyId = ''
    if (data) {
        for (const product of data) {
            if (product.reference) {
                if (!myData[product?.id]) {
                    myData[product?.id] = {
                        image: product.ProductImages?.[0]?.url,
                        name: product.ProductLangs?.[0]?.name,
                        ...dictStatsRows
                    }
                }
                if (product?.[info.typeSell +'Products']) {
                    for (const orderProduct of product[info.typeSell + 'Products']) {
                        if (orderProduct?.Order) {
                            if (!CurrencyId) {
                                CurrencyId = orderProduct?.Order?.CurrencyId || ''
                            }
                            const key = info.dictStatus?.[orderProduct?.Order?.status]
                            const { data, myTotalAmount } = getTotalAmounts(product.id, key, 'rowPriceWithoutTax', totalAmount, myData, typeTableName, orderProduct, 'ProductId', myTotalAmountDict)
                            myData = data
                            totalAmount = myTotalAmount
                            totalN += parseInt(orderProduct?.quantity)
                        }
                    }
                }
            }
        }
    }
    if (!CurrencyId) {
        CurrencyId = getISOCurrencyMain()
    }
    const result: TwinDictionary[] = []
    const dictionaryRows: TwinDictionary = {}
    const columns: ColumnTableSchema<TwinDictionary> = [
        {
            id: 'row',
            dataKey: 'row',
            label: '',
            width: 300,
        }
    ]
    for (const key in rows) {
        const element = rows[key]
        result.push({ row: element })
        dictionaryRows[element] = key
    }
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    for (const key in myData) {
        let element = myData[key]
        columns.push({
            id: key,
            dataKey: key,
            label: () => (
                <div className='flex items-center'>
                    <img src={element?.image || '/no-image.png'} alt='' className='logo_user rounded-full object-cover mr-10' />
                    <span>{element?.name}</span>
                </div>
            ),
            width: 200,
        })
        element = getTotalStatusStatsPercentatges(dictOrderStatus, typeTableName, element, totalAmount, totalN, CurrencySymbol)
        for (const key2 in element) {
            if (dictionaryRows[key2]) {
                result[dictionaryRows[key2]][key] = element[key2]
            }
        }
    }
    return { data: result, columns: columns, myTotalAmountDict, CurrencyId }
}

export const parseSellStatsByCategory = (data: any[], typeTableName: TypeSellTableNameTy) => {
    let myData: TwinDictionary = {}
    let totalN = 0
    let totalAmount = 0
    let myTotalAmountDict = {}
    let CurrencyId = ''
    const { rows, dictStatsRows, dictOrderStatus } = getStatesRowsBase(typeTableName)
    const info = dictOrderStatus[typeTableName]

    if (data) {
        for (const product of data) {
            if (product.reference) {
                const myId = product.Categories?.[0]?.id
                if (myId) {
                    if (!myData[myId]) {
                        myData[myId] = {
                            image: '',
                            name: product.Categories?.[0]?.CategoryLangs?.[0]?.name || 'Base',
                            ...dictStatsRows
                        }
                    }
                    if (product?.[info.typeSell + 'Products']) {
                        for (const orderProduct of product[info.typeSell + 'Products']) {
                            if (!CurrencyId) {
                                CurrencyId = orderProduct?.Order?.CurrencyId || ''
                            }
                            const key = info.dictStatus?.[orderProduct?.Order?.status]
                            const { data, myTotalAmount } = getTotalAmounts(myId, key, 'rowPriceWithoutTax', totalAmount, myData, typeTableName, orderProduct, 'CategoryId', myTotalAmountDict)
                            myData = data
                            totalAmount = myTotalAmount
                            totalN += parseInt(orderProduct?.quantity)
                        }
                    }
                }
            }
        }
    }
    if (!CurrencyId) {
        CurrencyId = getISOCurrencyMain()
    }
    const result: TwinDictionary[] = []
    const dictionaryRows: TwinDictionary = {}
    const columns: ColumnTableSchema<TwinDictionary> = [
        {
            id: 'row',
            dataKey: 'row',
            label: '',
            width: 300,
        }
    ]
    for (const key in rows) {
        const element = rows[key]
        result.push({ row: element })
        dictionaryRows[element] = key
    }
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    for (const key in myData) {
        let element = myData[key]
        columns.push({
            id: key,
            dataKey: key,
            label: () => (
                <div className='flex items-center'>
                    <span>{element.name}</span>
                </div>
            ),
            width: 200,
        })
        element = getTotalStatusStatsPercentatges(dictOrderStatus, typeTableName, element, totalAmount, totalN, CurrencySymbol)
        for (const key2 in element) {
            if (dictionaryRows[key2]) {
                result[dictionaryRows[key2]][key] = element[key2]
            }
        }
    }
    return { data: result, columns: columns, myTotalAmountDict, CurrencyId }
}